import axios from "@/plugins/http";
import { API_ROUTES } from "@/utils/API";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { API_TNotificationsStatus, TLastUnreadNewsNotification } from "@/models/notifications";
import { SMUser } from "..";

const REFRESH_INTERVAL_MINS = 30;

@Module({ name: "MNotifications", namespaced: true })
export default class MNotifications extends VuexModule {
  refreshIntervalId: number | null = null;
  refreshInterval = REFRESH_INTERVAL_MINS * 60 * 1000;

  hasNotifications = false;
  taskNotificationCount = 0;
  lastUnreadNewsNotification: TLastUnreadNewsNotification = {
    object_id: 0,
    title: "",
  };

  @Mutation
  setRefreshIntervalId(id: number) {
    this.refreshIntervalId = id;
  }

  @Mutation
  clearRefreshInterval() {
    if (this.refreshIntervalId !== null) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    }
  }

  // Tasks + Updates
  @Mutation
  setHasNotifications(has_notifications: boolean) {
    this.hasNotifications = has_notifications;
  }

  @Mutation
  setTaskNotificationCount(task_notification_count: number) {
    this.taskNotificationCount = task_notification_count;
  }

  @Mutation
  setLastUnreadNewsNotification(last_unread_news_notification: TLastUnreadNewsNotification | null) {
    Object.assign(this.lastUnreadNewsNotification, last_unread_news_notification);
  }

  @Action
  async fetchNotificationsStatus() {
    setTimeout(async () => {
      if (!SMUser.isUserSet || SMUser.isExpert) return;

      try {
        const { data } = await axios.get<API_TNotificationsStatus>(API_ROUTES.NOTIFICATIONS_STATUS);

        if (!data) return;

        this.context.commit("setHasNotifications", data.has_notifications);
        this.context.commit("setTaskNotificationCount", data.task_notification_count);
        this.context.commit("setLastUnreadNewsNotification", data.last_unread_news_notification);
      } catch (error) {
        console.error(`Error fetching NOTIFICATIONS_STATUS:`, error);
      }
    }, 1000);
  }

  @Action
  async startNotificationsRefresh() {
    if (this.refreshIntervalId !== null) {
      clearInterval(this.refreshIntervalId);
    }

    const intervalId = setInterval(async () => {
      try {
        await this.context.dispatch("fetchNotificationsStatus");
      } catch (error) {
        console.error("Failed to refresh notifications:", error);
      }
    }, this.refreshInterval);

    this.context.commit("setRefreshIntervalId", Number(intervalId));
  }

  @Action
  stopNotificationsRefresh() {
    this.context.commit("clearRefreshInterval");
  }

  get isLastUnreadNewsNotificationClosed() {
    return localStorage.getItem("is_notifications_closed") === "true";
  }

  @Action
  closeLastUnreadNewsNotification() {
    localStorage.setItem("is_notifications_closed", "true");

    this.context.commit("setLastUnreadNewsNotification", {
      object_id: 0,
      title: "",
    });
  }
}
